var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[(_vm.opened)?_c('div',{staticClass:"ds-help",style:(Object.assign({}, _vm.positionStyle,
      {transition: ("opacity " + _vm.transitionTime + "ms ease")})),on:{"mouseout":_vm.onMouseout}},[_c('div',{ref:"helpContent",class:[
        'ds-help-content',
        { 'ds-help-content-dark': _vm.dark },
        _vm.primaryAlignment
      ],style:({
        transition: ("transform " + _vm.transitionTime + "ms ease")
      })},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }